// cria um novo elemento html com os atributos passados no segundo parametro
const createElementHTML = (el_name, obj_attr, content = '') => {
    const el_new = document.createElement(el_name);

    if (null !== obj_attr && obj_attr instanceof Object && !(obj_attr instanceof Array)) {

        Object.getOwnPropertyNames(obj_attr).forEach((a) => {

            const attr_new = document.createAttribute(a);
            attr_new.value = obj_attr[a];
            el_new.setAttributeNode(attr_new);

        });

    }

    el_new.innerHTML = content;

    return el_new;
};

const validaCPF = function (value, element) {
    value = jQuery.trim(value);

    value = value.replace('.', '');
    value = value.replace('.', '');
    var cpf = value.replace('-', '');

    if (cpf.length < 9) return false;

    while (cpf.length < 11) cpf = "0" + cpf;

    var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
    var a = [];
    var b = new Number;
    var c = 11;
    for (var i = 0; i < 11; i++) {
        a[i] = cpf.charAt(i);
        if (i < 9) b += (a[i] * --c);
    }
    var x;
    if ((x = b % 11) < 2) {
        a[9] = 0
    } else {
        a[9] = 11 - x
    }
    b = 0;
    c = 11;
    for (var y = 0; y < 10; y++) b += (a[y] * c--);
    if ((x = b % 11) < 2) {
        a[10] = 0;
    } else {
        a[10] = 11 - x;
    }

    var retorno = true;
    if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) retorno = false;

    return this.optional(element) || retorno;

}

const validaCelular = function (value, element) {

    const onlynumber = value.replace(/[^\d]+/g, '');

    if (!element.hasAttribute("required") && value == '') return true;

    if (onlynumber.length != 11 && onlynumber.length != 10)
        return false;

    // Elimina numeros invalidos conhecidos
    if (onlynumber == "00000000000" ||
        onlynumber == "11111111111" ||
        onlynumber == "22222222222" ||
        onlynumber == "33333333333" ||
        onlynumber == "44444444444" ||
        onlynumber == "55555555555" ||
        onlynumber == "66666666666" ||
        onlynumber == "77777777777" ||
        onlynumber == "88888888888" ||
        onlynumber == "99999999999")
        return false;

    const brazilianPhoneRegex = /^\(\d{2}\) \d{5}-\d{4}$/gi;
    return brazilianPhoneRegex.test(value);
};


export {
    createElementHTML,
    validaCPF,
    validaCelular
};